import { render, staticRenderFns } from "./PersistTokenView.vue?vue&type=template&id=c20380c6"
import script from "./PersistTokenView.vue?vue&type=script&lang=ts"
export * from "./PersistTokenView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports